/* eslint-disable complexity */

import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { TylerMatTableDataSource } from '../../../../shared-components/angular-material/extended.class';
import { detailExpand } from '../../../../shared-components/angular-material/mat-animations';
import { LoginService } from '../../../login/login.service';
import { V9ReportParameter } from '../../models/v9-report-parameter.model';
import { AreaField, MedicalArea } from './medical-data-listing-grid.model';

@Component({
    selector: 'app-medical-data-listing-grid',
    templateUrl: './medical-data-listing-grid.component.html',
    styleUrls: ['./medical-data-listing-grid.component.css'],
    animations: [detailExpand],
})
export class MedicalDataListingGridComponent implements OnInit {
    // @Input() parameters: V9ReportParameter[];
    @Input() reportParameters: V9ReportParameter[];
    @Output() syncParametersEvent = new EventEmitter<V9ReportParameter[]>();
    areaList: MedicalArea[] = [];
    angularMatData = new TylerMatTableDataSource();
    columnsToDisplay: string[] = ['Select', 'Area', 'Expand'];
    columnsToDisplayDetailRow: string[] = ['FIELDTEXT', 'FROM', 'TO'];
    strStateCode = 'IL';
    constructor(private loginService: LoginService,) {

    }
    ngOnInit() {
        // if (this.parameters && this.parameters.length > 0) {
        //     this.reportParameters = JSON.parse(JSON.stringify(this.parameters));
        // }
        this.initialize();
    }
    initialize() {
        this.strStateCode = this.loginService.LoginSettings.State;
        if (this.reportParameters && this.reportParameters.find(x => x.ControlType === 'medicaldatalistinggrid')) {
            const param = this.reportParameters.find(x => x.ControlType === 'medicaldatalistinggrid');
            const tempDataSource: any[] = JSON.parse(param.GridDataSource);
            tempDataSource.filter(x => x.MEDICALAREA).forEach(area => {
                this.areaList.push({ ID: area.ID, MEDICALAREA: area.MEDICALAREA, Fileds: [] } as MedicalArea);
            });
            const allFields: AreaField[] = tempDataSource.filter(x => x.FIELDDATATYPE && x.FIELDTEXT);
            this.areaList.forEach(element => {
                element.Select = false;
                element.Fileds = allFields.filter(x => x.SUBID == element.ID);
                element.Fileds.forEach(field => {
                    if (field.DEFAULTVALUE.length > 0) {
                        field.Lookup = [];
                        field.DEFAULTVALUE.split('|').forEach(value => {
                            if (value.split(',')[0].length > 0) {
                                field.Lookup.push({
                                    Id: '', IsSelected: false, ValueField: value.split(',')[0], TextField: value.split(',')[1]
                                });
                            }
                        });
                    }

                });
            });
            this.angularMatData = new TylerMatTableDataSource(this.areaList);
            // this.expandAll(true);

        }
    }

    toggleExpanded(row: any) {
        this.angularMatData.toggleExpanded(row);
    }

    checkExpanded(row: any): boolean {
        return this.angularMatData.checkExpanded(row);
    }

    expandAll(expand: boolean) {
        this.angularMatData.expandAll(expand);
    }

    validate(area: MedicalArea, selectedfield: AreaField) {

        let strPutQuote = '';
        let strimmunizationWhere = '';
        let strMedicationWhere = '';
        let strMedicalConditionWhere = '';
        let strPhysicianWhere = '';
        let strHearingScreeningWhere = '';
        let strSpinalScreeningWhere = '';
        let strVisionScreeningWhere = '';
        let strDentalExamWhere = '';
        let strRestrictionsWhere = '';
        let strClinicLogWhere = '';
        let strPregnancyWhere = '';
        let strPhysicalExamWhere = '';
        const dtMinDate: Date = new Date(1900, 1, 1);
        const dtMaxDate: Date = new Date(2079, 6, 6);
        let strSelectionCriteria = '';

        let strOpenParens = '';
        let strCloseParens = '';
        area.Fileds.forEach(field => {
            if (field.FIELDDATATYPE.toUpperCase() == 'DATETYPE') {
                if (typeof (field.FROM) == 'object') { field.FROM = new Date(field.FROM).toLocaleDateString(); }
                if (typeof (field.TO) == 'object') { field.TO = new Date(field.TO).toLocaleDateString(); }
            }
            if (field.FROM.trim().length > 0) {

                // FROM Condition
                let strSign = '>=';
                let strAndOr = ' AND ';

                switch (field.FIELDDATATYPE.toUpperCase()) {
                    case 'STRINGTYPE':
                        strPutQuote = '\'';
                        break;
                    case 'STRINGTYPEEQUALS':
                        strPutQuote = '\'';
                        strSign = ' = ';
                        if (field.TO.trim().length > 0) {
                            strOpenParens = '(';
                            strCloseParens = ')';
                            strAndOr = ' OR ';
                        }

                        break;
                    case 'INTEGERTYPE':
                        const tempValue = parseInt(field.FROM);
                        if (isNaN(tempValue) == false) {
                            // TODO throw ("Invalid Numeric Value in Data From!");
                        }
                        strPutQuote = '';
                        break;
                    case 'BOOLEANTYPE':
                        strPutQuote = '';
                        break;
                    case 'BOOLEANTYPEEQUALS':
                        strPutQuote = '';
                        strSign = ' = ';
                        break;
                    case 'DATETYPE':
                        if ((new Date(field.FROM) > dtMaxDate) || (new Date(field.FROM) < dtMinDate)) {
                            // throw Date From must be between dtMinDate and dtMaxDate
                        }

                        strPutQuote = '\'';
                        break;
                }

                // ---- taking value
                switch (area.MEDICALAREA.toUpperCase()) {
                    case 'IMMUNIZATION':
                        strimmunizationWhere = strimmunizationWhere + ' '
                            + field.FIELDVALUE + ' >= '
                            + strPutQuote
                            + field.FROM.trim()
                            + strPutQuote + ' And ';
                        break;
                    case 'MEDICATION':
                        strMedicationWhere = strMedicationWhere + ' '
                            + field.FIELDVALUE + ' >= '
                            + strPutQuote
                            + field.FROM.trim()
                            + strPutQuote + ' And ';
                        break;
                    case 'MEDICAL CONDITIONS':
                        strMedicalConditionWhere = strMedicalConditionWhere + ' '
                            + field.FIELDVALUE + ' >= '
                            + strPutQuote
                            + field.FROM.trim()
                            + strPutQuote + ' And ';
                        break;
                    case 'DENTAL EXAMS':
                        strDentalExamWhere = strDentalExamWhere + ' '
                            + field.FIELDVALUE + ' >= '
                            + strPutQuote
                            + field.FROM.trim()
                            + strPutQuote + ' And ';
                        break;
                    case 'CLINIC LOG/VISITS':
                        strClinicLogWhere = strClinicLogWhere + ' '
                            + field.FIELDVALUE + ' >= '
                            + strPutQuote
                            + field.FROM.trim()
                            + strPutQuote + ' And ';
                        break;
                    case 'HEARING SCREENINGS':
                        strHearingScreeningWhere = strHearingScreeningWhere + ' '
                            + strOpenParens
                            + field.FIELDVALUE
                            + strSign
                            + strPutQuote
                            + field.FROM.trim()
                            + strPutQuote + strAndOr;
                        break;
                    case 'PHYSICAL EXAM':
                        strPhysicalExamWhere = strPhysicalExamWhere + ' '
                            + field.FIELDVALUE + ' >= '
                            + strPutQuote
                            + field.FROM.trim()
                            + strPutQuote + ' And ';
                        break;
                    case 'PHYSICIAN INFORMATION':
                        strPhysicianWhere = strPhysicianWhere + ' '
                            + field.FIELDVALUE + ' >= '
                            + strPutQuote
                            + field.FROM.trim()
                            + strPutQuote + ' And ';
                        break;
                    case 'RESTRICTIONS':
                        strRestrictionsWhere = strRestrictionsWhere + ' '
                            + field.FIELDVALUE + ' >= '
                            + strPutQuote
                            + field.FROM.trim()
                            + strPutQuote + ' And ';
                        break;
                    case 'SPINAL SCREENING':
                        strSpinalScreeningWhere = strSpinalScreeningWhere + ' '
                            + field.FIELDVALUE
                            + strSign
                            + strPutQuote
                            + field.FROM.trim()
                            + strPutQuote + ' And ';
                        break;
                    case 'VISION SCREENING':
                        strVisionScreeningWhere = strVisionScreeningWhere + ' '
                            + strOpenParens
                            + field.FIELDVALUE
                            + strSign
                            + strPutQuote
                            + field.FROM.trim()
                            + strPutQuote + strAndOr;
                        break;
                    case 'PREGNANCY':
                        strPregnancyWhere = strPregnancyWhere + ' '
                            + field.FIELDVALUE + ' >= '
                            + strPutQuote
                            + field.FROM.trim()
                            + strPutQuote + ' And ';
                        break;
                }

            }

            if (field.TO.trim().length > 0) {
                let strSign = '>=';
                switch (field.FIELDDATATYPE.toUpperCase()) {
                    case 'STRINGTYPEEQUALS':
                        strPutQuote = '\'';
                        strSign = ' = ';
                        break;
                    case 'STRINGTYPE':
                        strPutQuote = '\'';
                        break;
                    case 'INTEGERTYPE':
                        const tempValue = parseInt(field.TO);
                        if (isNaN(tempValue) == false) {
                            // throw 'Invalid Numeric Value in Data To!'
                        }

                        break;
                    case 'BOOLEANTYPE':
                        break;
                    case 'DATETYPE':
                        strSign = ' <= ';
                        if ((new Date(field.TO) > dtMaxDate) || (new Date(field.TO) < dtMinDate)) {
                            //  throw 'Date To must be between dtMinDate and dtMaxDate
                        }

                        strPutQuote = '\'';
                        break;
                }

                // ---- taking value
                switch (area.MEDICALAREA.toUpperCase()) {
                    case 'IMMUNIZATION':
                        strimmunizationWhere = strimmunizationWhere + ' '
                            + field.FIELDVALUE + ' <= '
                            + strPutQuote
                            + field.TO.trim()
                            + strPutQuote + ' And ';
                        break;
                    case 'MEDICATION':
                        strMedicationWhere = strMedicationWhere + ' '
                            + field.FIELDVALUE + ' <= '
                            + strPutQuote
                            + field.TO.trim()
                            + strPutQuote + ' And ';
                        break;
                    case 'MEDICAL CONDITIONS':
                        strMedicalConditionWhere = strMedicalConditionWhere + ' '
                            + field.FIELDVALUE + ' <= '
                            + strPutQuote
                            + field.TO.trim()
                            + strPutQuote + ' And ';
                        break;
                    case 'DENTAL EXAMS':
                        strDentalExamWhere = strDentalExamWhere + ' '
                            + field.FIELDVALUE + ' <= '
                            + strPutQuote
                            + field.TO.trim()
                            + strPutQuote + ' And ';
                        break;
                    case 'CLINIC LOG/VISITS':
                        strClinicLogWhere = strClinicLogWhere + ' '
                            + field.FIELDVALUE + ' <= '
                            + strPutQuote
                            + field.TO.trim()
                            + strPutQuote + ' And ';
                        break;
                    case 'HEARING SCREENINGS':
                        strHearingScreeningWhere = strHearingScreeningWhere + ' '
                            + field.FIELDVALUE
                            + strSign
                            + strPutQuote
                            + field.TO.trim()
                            + strPutQuote
                            + strCloseParens + ' And ';
                        break;
                    case 'PHYSICAL EXAM':
                        strPhysicalExamWhere = strPhysicalExamWhere + ' '
                            + field.FIELDVALUE + ' <= '
                            + strPutQuote
                            + field.TO.trim()
                            + strPutQuote + ' And ';
                        break;
                    case 'PHYSICIAN INFORMATION':
                        strPhysicianWhere = strPhysicianWhere + ' '
                            + field.FIELDVALUE + ' <= '
                            + strPutQuote
                            + field.TO.trim()
                            + strPutQuote + ' And ';
                        break;
                    case 'RESTRICTIONS':
                        strRestrictionsWhere = strRestrictionsWhere + ' '
                            + field.FIELDVALUE + ' <= '
                            + strPutQuote
                            + field.TO.trim()
                            + strPutQuote + ' And ';
                        break;
                    case 'SPINAL SCREENING':
                        strSpinalScreeningWhere = strSpinalScreeningWhere + ' '
                            + field.FIELDVALUE + ' <= '
                            + strPutQuote
                            + field.TO.trim()
                            + strPutQuote + ' And ';
                        break;
                    case 'VISION SCREENING':
                        strVisionScreeningWhere = strVisionScreeningWhere + ' '
                            + field.FIELDVALUE
                            + strSign
                            + strPutQuote
                            + field.TO.trim()
                            + strPutQuote
                            + strCloseParens + ' And ';
                        break;
                    case 'PREGNANCY':
                        strPregnancyWhere = strPregnancyWhere + ' '
                            + field.FIELDVALUE + ' <= '
                            + strPutQuote
                            + field.TO.trim()
                            + strPutQuote + ' And ';
                        break;
                }

            }

            // '----------------- Now Adding the selecting Criteria which user selected
            if (field.FROM.length > 0) {
                if (area.MEDICALAREA.toUpperCase() == 'VISION SCREENING') {
                    const strFieldName: string = field.FIELDTEXT;
                    let strValueToUse: string = field.FROM + (field.TO.length > 0 ? ' => ' : '') + field.TO;
                    if (this.strStateCode == 'IL') {
                        if (field.FIELDTEXT.toLowerCase().trim().startsWith('diagnosis')) {
                            strValueToUse = strValueToUse.replace('1', 'Normal');
                            strValueToUse = strValueToUse.replace('2', 'Mypoia');
                            strValueToUse = strValueToUse.replace('3', 'Hyperopia');
                            strValueToUse = strValueToUse.replace('4', 'Astigmatism');
                            strValueToUse = strValueToUse.replace('5', 'Strabismus');
                            strValueToUse = strValueToUse.replace('6', 'Amblyopia');
                            strValueToUse = strValueToUse.replace('7', 'Other');
                            if (strValueToUse.trim().indexOf('=>') >= 0) {
                                strValueToUse = strValueToUse.replace('=>', 'Or');
                            }

                        }

                        if (strFieldName.toLowerCase().trim().startsWith('screening tool')) {
                            if ((strValueToUse == null)) {
                                strValueToUse = '';
                            }

                            if (strValueToUse.trim().indexOf('=>') >= 0) {
                                const strList: string[] = strValueToUse.split('=>');
                                strValueToUse = '';
                                if ((strList.length >= 2)) {
                                    let strValueOne: string = strList[0];
                                    strValueOne = strValueOne.trim().replace('>', '').replace('=', '').trim();
                                    let strValueTwo: string = strList[1];
                                    strValueTwo = strValueTwo.trim().replace('>', '').replace('=', '').trim();
                                    const strFirst: string = this.getScreeningToolStr(strValueOne);
                                    const strSecond: string = this.getScreeningToolStr(strValueTwo);
                                    strValueToUse = (strFirst + (' => ' + strSecond));
                                }
                                else {
                                    strValueToUse = this.getScreeningToolStr(strValueToUse);
                                }

                                //  end if there is just one value, not => set of values
                            }

                        }

                    }

                    strSelectionCriteria = '******  VISION SCREENING ******;' + field.FIELDTEXT + ' : ' + strValueToUse;
                }
                else {
                    strSelectionCriteria = '****** ' + area.MEDICALAREA + ' ******;'
                        + field.FIELDTEXT + ' : ' + field.FROM + (field.TO.length > 0 ? ' => ' : '') + field.TO;
                }
            }
            else {
                strSelectionCriteria = 'Any Records!';
            }
        });
        this.reportParameters = this.reportParameters.filter(x => x.ParameterName != 'strClinicLogWhere' && x.ParameterName != 'strDentalExamWhere'
            && x.ParameterName != 'strHearingScreeningWhere' && x.ParameterName != 'strImmunizationWhere'
            && x.ParameterName != 'strMedicalConditionWhere' && x.ParameterName != 'strMedicationWhere'
            && x.ParameterName != 'strPhysicalExamWhere' && x.ParameterName != 'strPhysicianWhere'
            && x.ParameterName != 'strPregnancyWhere' && x.ParameterName != 'strRestrictionsWhere'
            && x.ParameterName != 'strSpinalScreeningWhere' && x.ParameterName != 'strVisionScreeningWhere');
        // SET VALUES IN PARAMETERstr.slice(0, str.length - 3)
        if (strClinicLogWhere && strClinicLogWhere.trim().length > 0) {
            this.reportParameters.push(this.createNewParam('strClinicLogWhere', strClinicLogWhere.trim().slice(0, strClinicLogWhere.trim().length - 3)));
        }
        else{
            this.reportParameters.push(this.createNewParam('strClinicLogWhere', ' '));
        }
        if (strDentalExamWhere && strDentalExamWhere.trim().length > 0) {
            this.reportParameters.push(this.createNewParam('strDentalExamWhere', strDentalExamWhere.trim().slice(0, strDentalExamWhere.trim().length - 3)));
        }
        else{
            this.reportParameters.push(this.createNewParam('strDentalExamWhere', ' '));
        }
        if (strHearingScreeningWhere && strHearingScreeningWhere.trim().length > 0) {
            this.reportParameters.push(this.createNewParam('strHearingScreeningWhere', strHearingScreeningWhere.trim().slice(0, strHearingScreeningWhere.trim().length - 3)));
        }else{
            this.reportParameters.push(this.createNewParam('strHearingScreeningWhere', ' '));
        }

        if (strimmunizationWhere && strimmunizationWhere.trim().length > 0) {
            this.reportParameters.push(this.createNewParam('strImmunizationWhere', strimmunizationWhere.trim().slice(0, strimmunizationWhere.trim().length - 3)));
        }else{
            this.reportParameters.push(this.createNewParam('strImmunizationWhere', ' '));
        }

        if (strMedicalConditionWhere && strMedicalConditionWhere.trim().length > 0) {
            this.reportParameters.push(this.createNewParam('strMedicalConditionWhere', strMedicalConditionWhere.trim().slice(0, strMedicalConditionWhere.trim().length - 3)));
        }else{
            this.reportParameters.push(this.createNewParam('strMedicalConditionWhere', ' '));
        }

        if (strMedicationWhere && strMedicationWhere.trim().length > 0) {
            this.reportParameters.push(this.createNewParam('strMedicationWhere', strMedicationWhere.trim().slice(0, strMedicationWhere.trim().length - 3)));
        }else{
            this.reportParameters.push(this.createNewParam('strMedicationWhere', ' '));
        }

        if (strPhysicalExamWhere && strPhysicalExamWhere.trim().length > 0) {
            this.reportParameters.push(this.createNewParam('strPhysicalExamWhere', strPhysicalExamWhere.trim().slice(0, strPhysicalExamWhere.trim().length - 3)));
        }else{
            this.reportParameters.push(this.createNewParam('strPhysicalExamWhere', ' '));
        }

        if (strPhysicianWhere && strPhysicianWhere.trim().length > 0) {
            this.reportParameters.push(this.createNewParam('strPhysicianWhere', strPhysicianWhere.trim().slice(0, strPhysicianWhere.trim().length - 3)));
        }else{
            this.reportParameters.push(this.createNewParam('strPhysicianWhere', ' '));
        }

        if (strPregnancyWhere && strPregnancyWhere.trim().length > 0) {
            this.reportParameters.push(this.createNewParam('strPregnancyWhere', strPregnancyWhere.trim().slice(0, strPregnancyWhere.trim().length - 3)));
        }else{
            this.reportParameters.push(this.createNewParam('strPregnancyWhere', ' '));
        }

        if (strRestrictionsWhere && strRestrictionsWhere.trim().length > 0) {
            this.reportParameters.push(this.createNewParam('strRestrictionsWhere', strRestrictionsWhere.trim().slice(0, strRestrictionsWhere.trim().length - 3)));
        }else{
            this.reportParameters.push(this.createNewParam('strRestrictionsWhere', ' '));
        }

        if (strSpinalScreeningWhere && strSpinalScreeningWhere.trim().length > 0) {
            this.reportParameters.push(this.createNewParam('strSpinalScreeningWhere', strSpinalScreeningWhere.trim().slice(0, strSpinalScreeningWhere.trim().length - 3)));
        }else{
            this.reportParameters.push(this.createNewParam('strSpinalScreeningWhere', ' '));
        }

        if (strVisionScreeningWhere && strVisionScreeningWhere.trim().length > 0) {
            this.reportParameters.push(this.createNewParam('strVisionScreeningWhere', strVisionScreeningWhere.trim().slice(0, strVisionScreeningWhere.trim().length - 3)));
        }else{
            this.reportParameters.push(this.createNewParam('strVisionScreeningWhere', ' '));
        }

        // if (strClinicLogWhere && strClinicLogWhere.trim().length > 0) {
        //     this.reportParameters.push(this.createNewParam('strClinicLogWhere', strClinicLogWhere.trim()));
        // }
        if (this.reportParameters.find(x => x.ParameterName == 'MedSelectionCriteria')) {
            this.reportParameters.find(x => x.ParameterName == 'MedSelectionCriteria').Value = strSelectionCriteria ? strSelectionCriteria : '';
        }
        // if (this.reportParameters && this.reportParameters.length > 0) {
        //     this.parameters = JSON.parse(JSON.stringify(this.reportParameters));
        // }
        this.reportParameters = [...this.reportParameters];
        this.syncParametersEvent.emit(this.reportParameters);
        return true;

    }

    getScreeningToolStr(strIdString: string): string {
        let strScreeningTool = '';
        if (strIdString.trim() == '1') {
            strScreeningTool = 'Snellen';
        }
        else if (strIdString.trim() == '2') {
            strScreeningTool = 'Snellen-E';
        }
        else if (strIdString.trim() == '3') {
            strScreeningTool = 'Titmus';
        }
        else if (strIdString.trim() == '4') {
            strScreeningTool = 'McDowell';
        }
        else if (strIdString.trim() == '5') {
            strScreeningTool = 'LEA';
        }
        else if (strIdString.trim() == '6') {
            strScreeningTool = 'Lighthouse';
        }
        else if (strIdString.trim() == '7') {
            strScreeningTool = 'Sloan';
        }
        else if (strIdString.trim() == '8') {
            strScreeningTool = 'HOTV';
        }
        else if (strIdString.trim() == '9') {
            strScreeningTool = 'Sure Sight';
        }
        else if (strIdString.trim() == '10') {
            strScreeningTool = 'Photoscreener';
        }

        return strScreeningTool;
    }

    createNewParam(parameterName: string, value: string): V9ReportParameter {
        return {
            Id: 0,
            ParentId: 0,
            Name: '',
            ColumnName: '',
            ParameterName: parameterName,
            DataType: '',
            ControlType: '',
            Value: value,
            ParentValue: null,
            Hint: '',
            MaxLength: 0,
            RowNumberInTable: 0,
            ColumnNumberInTable: 0,
            SpanNumberOfRows: 0,
            SpanNumberOfColumns: 0,
            ChildPaddingLeft: 0,
            ShowOptionsVertically: false,
            IncludeLineAtStartOfGroup: false,
            IncludeLineAtEndOfGroup: false,
            IsVisible: false,
            IsRequired: false,
            UserPreferencesParameterName: '',
            ParameterStyle: '',
            DataSource: [],
            Disabled: false,
            GridDataSource: '',
            LookupProcedureName: '',
            IsLetterParameter: false,
            TabName: '',
            GridDataSources: null,
            ColumnToDisplay: [],
            ColumnControlSpec: [],
            selectedStaffNames: '',
            selectedStaffNumbers: '',
            staffpickerControlType: '',



        } as V9ReportParameter;
    }

    medicalAreaChkChange() {

        if (this.reportParameters && this.reportParameters.length > 0) {
            this.areaList.forEach(area => {

                if (area.MEDICALAREA.toUpperCase() == 'IMMUNIZATION') {
                    this.reportParameters.filter(x => x.ParameterName == 'blnDisplayImmunization')[0].Value = area.Select;
                }

                if (area.MEDICALAREA.toUpperCase() == 'MEDICATION') {
                    this.reportParameters.filter(x => x.ParameterName == 'blnDisplayMedication')[0].Value = area.Select;
                }
                if (area.MEDICALAREA.toUpperCase() == 'MEDICAL CONDITIONS') {
                    this.reportParameters.filter(x => x.ParameterName == 'blnDisplayMedicalCondition')[0].Value = area.Select;
                }
                if (area.MEDICALAREA.toUpperCase() == 'DENTAL EXAMS') {
                    this.reportParameters.filter(x => x.ParameterName == 'blnDisplayDentalExam')[0].Value = area.Select;
                }
                if (area.MEDICALAREA.toUpperCase() == 'CLINIC LOG/VISITS') {
                    this.reportParameters.filter(x => x.ParameterName == 'blnDisplayClinicLog')[0].Value = area.Select;
                }
                if (area.MEDICALAREA.toUpperCase() == 'HEARING SCREENINGS') {
                    this.reportParameters.filter(x => x.ParameterName == 'blnDisplayHearingScreening')[0].Value = area.Select;
                }
                if (area.MEDICALAREA.toUpperCase() == 'PHYSICAL EXAM') {
                    this.reportParameters.filter(x => x.ParameterName == 'blnDisplayPhysicalExam')[0].Value = area.Select;
                }
                if (area.MEDICALAREA.toUpperCase() == 'PHYSICIAN INFORMATION') {
                    this.reportParameters.filter(x => x.ParameterName == 'blnDisplayPhysician')[0].Value = area.Select;
                }
                if (area.MEDICALAREA.toUpperCase() == 'RESTRICTIONS') {
                    this.reportParameters.filter(x => x.ParameterName == 'blnDisplayRestrictions')[0].Value = area.Select;
                }
                if (area.MEDICALAREA.toUpperCase() == 'SPINAL SCREENING') {
                    this.reportParameters.filter(x => x.ParameterName == 'blnDisplaySpinalScreening')[0].Value = area.Select;
                }
                if (area.MEDICALAREA.toUpperCase() == 'VISION SCREENING') {
                    this.reportParameters.filter(x => x.ParameterName == 'blnDisplayVisionScreening')[0].Value = area.Select;
                }
                if (area.MEDICALAREA.toUpperCase() == 'PREGNANCY') {
                    this.reportParameters.filter(x => x.ParameterName == 'blnDisplayPregnancy')[0].Value = area.Select;
                }

                area.Fileds.forEach(field => {
                    if (area.Select) {
                        this.validate(area, field);
                    }
                });
            });

        }

    }

    dateChange(date: Date, area: MedicalArea, field: AreaField, type: string) {
        if (type == 'FROM') {
            field.FROM = new Date(date).toLocaleDateString();
        } else if (type == 'TO') {
            field.TO = new Date(date).toLocaleDateString();
        }
        this.validate(area, field);
    }
}
